var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 16,
  viewBox: "0 0 16 16",
  width: 16,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m4.25 6.96v-1.46c0-.99456.39509-1.94839 1.09835-2.65165s1.65709-1.09835 2.65165-1.09835 1.94839.39509 2.6517 1.09835c.7032.70326 1.0983 1.65709 1.0983 2.65165v1.46c.7388.35125 1.25 1.105 1.25 1.9775v3.125c0 .5802-.2305 1.1366-.6407 1.5468s-.9666.6407-1.5468.6407h-5.625c-.58016 0-1.13656-.2305-1.5468-.6407-.41023-.4102-.6407-.9666-.6407-1.5468v-3.125c0-.8725.51125-1.625 1.25-1.9775zm5.625-.21v-1.25c0-.49728-.19754-.97419-.54917-1.32583-.35164-.35163-.82855-.54917-1.32583-.54917s-.97419.19754-1.32583.54917c-.35163.35164-.54917.82855-.54917 1.32583v1.25z",
  fill: "currentColor"
})));
export default SvgLock;